import { render } from "./RoleDetailPage.vue?vue&type=template&id=a3c4460c&ts=true"
import script from "./RoleDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoleDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/role/RoleDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a3c4460c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a3c4460c', __exports__)) {
    api.reload('a3c4460c', __exports__)
  }
  
  module.hot.accept("./RoleDetailPage.vue?vue&type=template&id=a3c4460c&ts=true", () => {
    api.rerender('a3c4460c', render)
  })

}


export default __exports__